import { render, staticRenderFns } from "./clients-section.vue?vue&type=template&id=48d815da&scoped=true&"
import script from "./clients-section.vue?vue&type=script&lang=ts&"
export * from "./clients-section.vue?vue&type=script&lang=ts&"
import style0 from "./clients-section.vue?vue&type=style&index=0&id=48d815da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d815da",
  null
  
)

export default component.exports